import { render, staticRenderFns } from "./AudienceCampaigns.vue?vue&type=template&id=2b8c7a0c&scoped=true"
import script from "./AudienceCampaigns.vue?vue&type=script&lang=js"
export * from "./AudienceCampaigns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8c7a0c",
  null
  
)

export default component.exports